/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// 16×16 verified-checkmark badge next to chat-row names in the new
// chat-home design (Figma node 3281:98498). The badge uses the
// `accent.verified` design-token (cyan `#2ca8d4`) — both light and
// dark modes share the same hue.

import { View, useColorScheme } from 'react-native';
import { BadgeCheck } from 'lucide-react-native';
import { tokens } from '../design-system/tokens';

export interface VerifiedBadgeProps {
	readonly verified: boolean;
	readonly size?: number;
}

export function VerifiedBadge({ verified, size = 16 }: VerifiedBadgeProps): JSX.Element | null {
	const scheme = useColorScheme();
	const colorScheme = scheme === 'dark' ? 'dark' : 'light';
	const color = tokens.color.semantic[colorScheme].accent.verified;
	if (!verified) return null;
	return (
		<View
			accessibilityLabel="verified"
			accessibilityRole="image"
			className="items-center justify-center"
			style={{ width: size, height: size }}
		>
			<BadgeCheck size={size} color={color} fill={color} strokeWidth={2} />
		</View>
	);
}
